import React from 'react'
import { getEnvironment } from '../../utils/environment'
import './EnvironmentBanner.scss'

function EnvironmentBanner() {
  const environment = getEnvironment()
  
  // Don't show banner for production
  if (!environment || environment === 'prod') {
    return null
  }
  
  return (
    <div className={`environment-banner environment-banner-${environment}`}>
      <div className="container">
        <div className="text-center py-2">
          <strong>{environment.toUpperCase()}</strong> Environment
        </div>
      </div>
    </div>
  )
}

export default EnvironmentBanner

